import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Accordion.css";

class Accordion extends Component {
  renderChildren() {
    return React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        isAccordion: this.props.isAccordion,
        defaultActiveKey: this.props.defaultActiveKey,
        activeCandidateId: this.props.activeCandidateId
      });
    });
  }

  render() {
    return <div className="accordion-wrapper">{this.renderChildren()}</div>;
  }
}

Accordion.propTypes = {
  title: PropTypes.string
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/UI/Accordion/Accordion.js